import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import { fetchGroupsFilteredByPartner } from '../modules/group'
import { createUser,
  deleteUser,
  fetchPartner,
  fetchUsers,
  fetchUserProfile,
  resendVerificationEmail,
  resetPassword,
  setFilter } from '../modules/user'
import FormDialog from '../components/formDialog'
import Messages from '../constants/messages'
import { nordAdmins, partnerAccessAdmin } from '../constants/memberships'
import { paginationChangePage,
  paginationChangeRowsPerPage,
  searchOnChange } from '../modules/table'
import { push } from 'react-router-redux'
import { required, email, emailDomain, lookUpRequired } from '../utils/validationRules'
import { setConfirmationItem, showDialog, resetForm, resetFormValue, resetLookUpValue } from '../modules/formDialog'
import TableDisplay from '../components/tableDisplay'
import { userTableOptions } from '../constants/tableConfigs'
import withStyles from 'material-ui/styles/withStyles'
import { getAdminTypeString, hasRole, hasMembership } from '../utils/helpers'
import { unflagDataRefresh } from '../modules/refresh'

const PROP_TYPES = {
  classes: PropTypes.object.isRequired,
  lookUpValue: PropTypes.string,
  open: PropTypes.bool.isRequired,
  totalCount: PropTypes.number.isRequired,
  userMemberships: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired
}

const styles = theme => ({
  root: {
    maxWidth: '100%',
    margin: 'auto'
  },
  pageMessage: theme.pageMessage
})

const dialogOptions = {
  'System-Admin': [
    {
      type: 'partnerManualLookup',
      name: 'partnerId',
      friendlyName: Messages['uiComponents']['PARTNER_ID_INPUT_FIELD'],
      validationRules: [lookUpRequired]
    },
    {
      type: 'textField',
      name: 'firstName',
      friendlyName: Messages['uiComponents']['FIRST_NAME_INPUT_FIELD'],
      validationRules: [required]
    },
    {
      type: 'textField',
      name: 'lastName',
      friendlyName: Messages['uiComponents']['LAST_NAME_INPUT_FIELD'],
      validationRules: [required]
    },
    {
      type: 'textField',
      name: 'email',
      friendlyName: Messages['uiComponents']['EMAIL_INPUT_FIELD'],
      validationRules: [required, email, emailDomain]
      //helperText: 'Comma seperated',
      //multiline: true
    },
    {
      type: 'groupDropdown',
      name: 'groupIds',
      friendlyName: Messages['uiComponents']['GROUP_DROPDOWN_FIELD'],
      validationRules: [required]
    }
  ],
  'Application-Admin': [
    {
      type: 'partnerManualLookup',
      name: 'partnerId',
      friendlyName: Messages['uiComponents']['PARTNER_ID_INPUT_FIELD'],
      validationRules: [lookUpRequired]
    },
    {
      type: 'textField',
      name: 'firstName',
      friendlyName: Messages['uiComponents']['FIRST_NAME_INPUT_FIELD'],
      validationRules: [required]
    },
    {
      type: 'textField',
      name: 'lastName',
      friendlyName: Messages['uiComponents']['LAST_NAME_INPUT_FIELD'],
      validationRules: [required]
    },
    {
      type: 'textField',
      name: 'email',
      friendlyName: Messages['uiComponents']['EMAIL_INPUT_FIELD'],
      validationRules: [required, email, emailDomain]
      //helperText: 'Comma seperated',
      //multiline: true
    },
    {
      type: 'groupDropdown',
      name: 'groupIds',
      friendlyName: Messages['uiComponents']['GROUP_DROPDOWN_FIELD'],
      validationRules: [required]
    }
  ],
  'PartnerAccessAdmin': [
    {
      type: 'partnerDropdown',
      name: 'partnerId',
      friendlyName: Messages['uiComponents']['PARTNER_NAME_INPUT_FIELD'],
      multiple: false,
      validationRules: [required]
    },
    {
      type: 'textField',
      name: 'firstName',
      friendlyName: Messages['uiComponents']['FIRST_NAME_INPUT_FIELD'],
      validationRules: [required]
    },
    {
      type: 'textField',
      name: 'lastName',
      friendlyName: Messages['uiComponents']['LAST_NAME_INPUT_FIELD'],
      validationRules: [required]
    },
    {
      type: 'textField',
      name: 'email',
      friendlyName: Messages['uiComponents']['EMAIL_INPUT_FIELD'],
      validationRules: [required, email, emailDomain]
      //helperText: 'Comma seperated',
      //multiline: true
    },
    {
      type: 'groupDropdownPartnerAdmin',
      name: 'groupIds',
      friendlyName: Messages['uiComponents']['GROUP_DROPDOWN_FIELD'],
      validationRules: [required]
      //helperText: 'Comma seperated',
      //multiline: true
    }
  ],
  'forgotPassword': [
    {
      type: 'confirmation',
      name:'id',
      confirmationType:'forgotPassword'
    }
  ],
  'resendVerification': [
    {
      type: 'confirmation',
      name:'id',
      confirmationType:'resendVerification'
    }
  ],
  'delete': [
    {
      type: 'confirmation',
      name:'name',
      confirmationType: 'delete'
    }
  ]
}

export class Users extends Component {
  userOptions = userTableOptions.map((tableOption) => {
    if (tableOption.displayType === 'link') {
      return Object.assign(tableOption, {callback: (user) => {
        this.props.fetchUserProfile(user.id)
        this.props.changePage(user)
      }})
    } else {
      return {...tableOption}
    }
  })

  userTableButtons = [
    {
      buttonName: 'Email',
      callback: (user) => {
        this.props.setConfirmationItem(user)
        if (user.emailVerified) {
          this.props.showDialog(true, 'forgotPassword')
        } else {
          this.props.showDialog(true, 'resendVerification')
        }
      }
    },
    {
      buttonName: 'Clear',
      callback: (user) => {
        this.props.setConfirmationItem(user)
        this.props.showDialog(true, 'delete')
      },
      tooltip: Messages['tooltips']['DELETE']
    }
  ]

  componentWillMount() {
    const {
      dataRefreshRequired,
      fetchUsers,
      unflagDataRefresh } = this.props

    if (dataRefreshRequired) {
      unflagDataRefresh('users')
      fetchUsers(true)
    }
  }

  componentDidUpdate() {
    const { needPartnerFilteredGroups, fetchGroupsFilteredByPartner, formValues } = this.props
    if (needPartnerFilteredGroups && formValues.values && formValues.values.partnerId) {
      let partner = formValues.values.partnerId.includes('id') ?
        JSON.parse(formValues.values.partnerId) : {id: formValues.values.partnerId}
      fetchGroupsFilteredByPartner(partner)
    }
  }

  handleSubmit(values) {
    const {
      applicationId,
      confirmationItem,
      createUser,
      deleteUser,
      formType,
      lookUpValue,
      resetForm,
      resendVerificationEmail,
      resetPassword,
      userRoles } = this.props

    switch(formType) {
      case 'new':
        if(hasRole(userRoles, partnerAccessAdmin)) {
          createUser({...values, applicationId})
        } else {
          createUser({...values, applicationId}, values.partnerId, lookUpValue)
        }
        resetForm()
        break
      case 'delete':
        deleteUser(confirmationItem.id)
        resetForm()
        break
      case 'forgotPassword':
        resetPassword(confirmationItem.id)
        resetForm()
        break
      case 'resendVerification':
        resendVerificationEmail(confirmationItem.id)
        resetForm()
        break
      default:
        break
    }
  }

  getProgressIndicatorText(formType) {
    switch(formType) {
      case 'delete':
      return Messages['uiComponents']['DELETING_USER_MSG']
      case 'new':
        return Messages['uiComponents']['ADDING_USER_MSG']
      case 'forgotPassword':
        return Messages['uiComponents']['SENDING_EMAIL_MSG']
      case 'resendVerification':
        return Messages['uiComponents']['SENDING_EMAIL_MSG']
      default:
        return Messages['uiComponents']['LOADING_MSG']
    }
  }

  setTitle(formType) {
    switch(formType) {
      case 'delete':
        return Messages['confirmations']['DELETE_USER_TITLE']
      case 'new':
        return Messages['uiComponents']['ADD_USER_DIALOG_TITLE']
      case 'forgotPassword':
        return Messages['confirmations']['RESET_PASSWORD_TITLE']
      case 'resendVerification':
        return Messages['confirmations']['RESEND_VERIFY_EMAIL_TITLE']
      default:
        return ''
    }
  }

  render() {
    const {
      authProfile,
      filter,
      setFilter,
      classes,
      confirmationItem,
      fetchPartner,
      fetchUsers,
      formType,
      groupsFilteredByPartner,
      lookUpValue,
      paginationChangePage,
      paginationChangeRowsPerPage,
      paginationPage,
      paginationRowsPerPage,
      partners,
      resetLookUpValue,
      isLoadingDialog,
      isLoadingPartnerFilteredGroups,
      open,
      resetForm,
      resetFormValue,
      searchOnChange,
      searchValue,
      showDialog,
      totalCount,
      users,
      userMemberships,
      userRoles } = this.props

    const dialogType = getAdminTypeString(userMemberships, userRoles)
    let dataToDisplay = users
    if (authProfile.userRoles && authProfile.userRoles.includes("PartnerAccessAdmin")) {
      // TODO: Refactor this to be a one time filter on data fetch (instead of filtering each time users is rendered)
      // If user is PA Admin, they should only be able to edit users from the partner they are admin for
      // This filters out other partner users if the logged in user is an admin for one partner and user for others
      dataToDisplay = users.filter(user => {
        return user.partners.some(partner => {
          return authProfile.partners.some(adminPartner => adminPartner.id === partner.id)
        })
      })
    }

    return (
      <section className={classes.root}>
        <FormDialog
          buttonLabel={Messages['uiComponents']['ADD_USER_BUTTON_LABEL']}
          confirmationItem={confirmationItem}
          data={{partnerList: partners, groups: groupsFilteredByPartner}}
          dialogOptions={formType === 'new' ? dialogOptions[dialogType] : dialogOptions[formType]}
          handleFormSubmit={(values) => this.handleSubmit(values)}
          isLoading={isLoadingDialog}
          isLoadingPartnerFilteredGroups={isLoadingPartnerFilteredGroups}
          infoText={this.getProgressIndicatorText(formType)}
          lookUpValue={lookUpValue}
          lookUpFunc={fetchPartner}
          open={open}
          resetFormValue={resetFormValue}
          resetFormValues={resetForm}
          resetLookUpValue={resetLookUpValue}
          showDialog={showDialog}
          title={this.setTitle(formType)} />
        <p className={classes.pageMessage}>{Messages['pageHeaders']['USERS_PAGE_MSG']}</p>
        <TableDisplay
          authProfile={authProfile}
          data={dataToDisplay}
          fetchDataCallback={fetchUsers}
          filter={filter}
          filtered={hasRole(userRoles, partnerAccessAdmin) ? partners : null}
          page={paginationPage}
          paginationChangePage={paginationChangePage}
          paginationChangeRowsPerPage={paginationChangeRowsPerPage}
          rowsPerPage={paginationRowsPerPage}
          search={hasMembership(userMemberships, nordAdmins)}
          searchFieldLabel={Messages['uiComponents']['USER_SEARCH_LABEL']}
          searchOnChange={searchOnChange}
          searchValue={searchValue}
          setFilter={setFilter}
          serverSidePagination={true}
          tab="user"
          tableButtons={this.userTableButtons}
          tableOptions={this.userOptions}
          totalCount={totalCount}
          type="user" />
      </section>
    )
  }
}

Users.propTypes = PROP_TYPES

const mapStateToProps = state => ({
  applicationId: state.appContext.appInfo.id,
  authProfile: state.authProfile,
  confirmationItem: state.formDialog.confirmationItem,
  filter: state.user.filter,
  formType: state.formDialog.formType,
  formValues: state.form.dialogValues,
  groupsFilteredByPartner: state.group.groupsFilteredByPartner,
  isLoadingDialog: state.loading.isLoadingDialog,
  isLoadingPartnerFilteredGroups: state.loading.isLoadingPartnerFilteredGroups,
  lookUpValue: state.formDialog.lookUpValue,
  needPartnerFilteredGroups: state.user.needPartnerFilteredGroups,
  open: state.formDialog.open,
  paginationPage: state.table.paginationPage.user,
  paginationRowsPerPage: state.table.paginationRowsPerPage.user,
  partners: state.authProfile.partners,
  searchValue: state.table.searchValues.user,
  dataRefreshRequired: state.refresh.dataRefreshRequired.users,
  totalCount: state.user.totalCount,
  userMemberships: state.authProfile.userMemberships,
  userRoles: state.authProfile.userRoles,
  users: state.user.users
})

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: (user) => push({pathname: `/users/${user.id}`, state: user}),
  createUser,
  deleteUser,
  fetchGroupsFilteredByPartner,
  fetchPartner,
  fetchUsers,
  fetchUserProfile,
  resendVerificationEmail,
  resetLookUpValue,
  resetForm,
  resetFormValue,
  resetPassword,
  searchOnChange,
  setConfirmationItem,
  setFilter,
  showDialog,
  paginationChangePage,
  paginationChangeRowsPerPage,
  unflagDataRefresh
}, dispatch)

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Users)
